import { type NavigationItem } from '../types/navigation-items';

export const hasCurrentRouteSubMenu = (pathname: string, navigationItems: NavigationItem[]) => {
  const currentRouteSubMenu = navigationItems.find(
    (navigationItem) => navigationItem.route === pathname
  );

  return currentRouteSubMenu?.subMenu && currentRouteSubMenu.subMenu.length > 0;
};
